import Session from '../auth/Session';

function authHeaders() {
    const token = Session.getToken();
    return {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
    };
}

async function postPayment(path, body) {
    const response = await fetch(path, {
        method: 'POST',
        headers: authHeaders(),
        body: JSON.stringify(body),
    });

    // 402 = declined. Read the structured error; do not throw.
    if (response.status === 402) {
        const data = await safeJson(response);
        return { success: false, errorMessage: data?.errorMessage || 'Payment was declined.' };
    }

    if (!response.ok) {
        throw new Error(`${path} failed: ${response.status}`);
    }

    return response.json();
}

async function safeJson(response) {
    try {
        return await response.json();
    } catch {
        return null;
    }
}

// Authorize a hold on the funds. No money is captured yet. CARD ONLY.
export async function authorizePayment({ paymentToken, amount, idempotencyKey, formData }) {
    return postPayment('api/Payment/Authorize', {
        QuoteId: formData.QuoteId,
        PaymentToken: paymentToken,
        Amount: amount,
        IdempotencyKey: idempotencyKey,
        Email: formData.UserName,
        FirstName: formData.FirstName,
        LastName: formData.LastName,
        Phone: formData.PhoneNumberPrimary,
        OwnerType: formData.OwnerType,
        BillingZip: formData.BillingZip,
    });
}

// Immediate one-step sale. ACH ONLY (no auth/capture for check). Called AFTER the policy has been issued.
export async function salePayment({ paymentToken, amount, idempotencyKey, formData }) {
    return postPayment('api/Payment/Sale', {
        QuoteId: formData.QuoteId,
        PaymentToken: paymentToken,
        Amount: amount,
        IdempotencyKey: idempotencyKey,
        Email: formData.UserName,
        FirstName: formData.FirstName,
        LastName: formData.LastName,
        Phone: formData.PhoneNumberPrimary,
        OwnerType: formData.OwnerType,
        BillingZip: formData.BillingZip,
    });
}

// Capture a previously authorized transaction. Funds move here.
export async function capturePayment({ transactionId, amount, idempotencyKey, formData  }) {
    return postPayment('api/Payment/Capture', {
        QuoteId: formData.QuoteId,
        TransactionId: transactionId,
        Amount: amount,
        IdempotencyKey: idempotencyKey,
    });
}

// Compensating action - release an authorization when downstream issuance fails.
export async function voidAuthorization({ transactionId, idempotencyKey, formData  }) {
    return postPayment('api/Payment/Void', {
        QuoteId: formData.QuoteId,
        TransactionId: transactionId,
        IdempotencyKey: idempotencyKey,
    });
}